// this is javascript so it can be used by devops and others
/* global URL, URLSearchParams, window */

import routes from "./routes.json";

function getAllRoutesPrivate(start, result) {
  const at = start || routes;
  if (!(typeof at === "object" && !Array.isArray(at) && at !== null)) {
    return;
  }
  Object.keys(start).forEach((key) => {
    if (key == "url") {
      result.push(start[key]);
    } else {
      getAllRoutesPrivate(start[key], result);
    }
  });
}

export function getAllRoutes() {
  const found = [];
  getAllRoutesPrivate(routes, found);
  return found;
}

export function getRoutePath(value) {
  return routes[value]?.url;
}

export function getRoute(value) {
  const route = getRoutePath(value);
  const client = new URLSearchParams(window.location.search).get("client");

  if (!route || !client || /\.[^/]+$/.test(route.split(/[?#]/)[0])) {
    return route;
  }

  const url = new URL(route, window.location.origin);
  url.searchParams.set("client", client);
  return `${url.pathname}${url.search}${url.hash}`;
}
